import React from 'react';
import { Link } from 'react-router-dom';
import guard from '../../assets/home1.png'

function HomeHero() {
    return (
        <section data-theme="guardhartDark" className="relative w-full min-h-[600px] md:max-h-[870px] flex items-center overflow-hidden">
            <div className="absolute inset-0 z-0">
                <div
                    className="w-full h-full bg-cover bg-center bg-no-repeat bg-zinc-900"
                    style={{
                        backgroundImage: `url(${guard})`,
                    }}
                ></div>
                <div className="absolute inset-0 bg-gradient-to-r from-base-100 via-base-100/80 to-transparent "></div>
            </div>

            <div className="relative  px-6 md:px-12 max-w-7xl mx-auto w-full py-24 md:py-32">
                <div className="max-w-2xl">
                    <span className="text-xs font-bold uppercase tracking-widest text-primary mb-4 block">
                        Premier Security Solutions
                    </span>

                    <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-base-content mb-6 leading-tight">
                        Security you <br className="hidden md:block" />
                        can <span className="text-primary">trust.</span>
                    </h1>

                    <p className="text-base md:text-lg text-zinc-400 mb-8 max-w-lg leading-relaxed">
                        Professional guards, smart CCTV, and reliable protection for businesses and homes across Kenya. Engineered for absolute reliability and technical precision.
                    </p>

                    <div className="flex flex-wrap gap-4">
                        <Link
                            to="/services"
                            className="bg-primary text-primary-content px-8 py-3 text-xs font-bold uppercase tracking-widest rounded active:scale-95 transition-all hover:brightness-110"
                        >
                            Our Services
                        </Link>
                        <Link
                            to="/contact"
                            className="border border-zinc-700 text-zinc-100 px-8 py-3 text-xs font-bold uppercase tracking-widest rounded active:scale-95 transition-all hover:bg-zinc-800 hover:border-zinc-600"
                        >
                            Contact Us
                        </Link>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default HomeHero;